import { gql } from 'apollo-angular';
import { PaymentSubscription, StorageInfo } from '../../entities/payment/payment';
import { Tenant } from '../../entities/tenant/tenant';
import { TenantLicenceRequest } from '../../entities/tenant/tenantLicenceRequest';
import { TenantLicenceStatus } from '../../entities/tenantLicenceStatus/TenantLicenceStatus';

export const SUBSCRIPTION_QUERY = gql`
query getPaymentSubscription(
  $tenantId: String
)
{
  subscription: getPaymentSubscription(
    tenantId: $tenantId
  )
  {
    state
    startDateTime
    endDateTime
    trialEndDateTime
    discount {
      amountOff
      percentOff
      duration
      durationInMonths
      currency
      name
    }
    items {
      type
      quantity
      assigned
      price
      currency
      interval
      discount {
        amountOff
        percentOff
        duration
        durationInMonths
        currency
        name
      }
    }
    amountItems {
      productName
      quantity
      price
      currency
      interval
      currentMaxAmount
      totalAmountUsed
      amountUnit
      perUnitAmount
      discount {
        amountOff
        percentOff
        duration
        durationInMonths
        currency
        name
      }
    }
    otherItems {
      productName
      quantity
      price
      totalPrice
      currency
      interval
      discount {
        amountOff
        percentOff
        duration
        durationInMonths
        currency
        name
      }
    }
  }
  tenantLicenceRequests: getTenantLicenceRequests(
    filter: {
      tenantId: $tenantId,
      status: [PROCESSING],
      actionType: REMOVE
    }
  )
  {
    licenceType
    licenceCount
    paymentProviderFulfillmentDateTime
  }
  tenantLicenceRequestsStatuses: getTenantLicenceRequestsStatuses(
    filter: {
      tenantId: $tenantId,
      status: [PROCESSING]
    }
  )
  {
    isIncreaseProcessing
    isDecreaseProcessing
  }
  tenant: getTenantByTenantId(
    tenantId: $tenantId
  )
  {
    id
  }
  storageInfo: getStorageInfo(tenantId: $tenantId) {
    totalAmountUsed
    amountUnit
  }
}
`;

export interface SubscriptionQueryResponse {
    subscription: PaymentSubscription;
    tenantLicenceRequests: TenantLicenceRequest[];
    tenantLicenceRequestsStatuses: TenantLicenceStatus[];
    tenant: Tenant;
    storageInfo: StorageInfo;
    loading: boolean;
}

export const DECREASE_DELETION_STATUS_QUERY = gql`
query getDecreaseDeletionStatus(
  $tenantId: String
)
{
  tenantLicenceRequestsStatuses: getTenantLicenceRequestsStatuses(
    filter: {
      tenantId: $tenantId,
      status: [PROCESSING],
      actionType: REMOVE
    }
  )
  {
    tenantLicenceRequest{
      id
    }
  }
}
`;

export interface DecreaseDeletionStatusQueryResponse {
    tenantLicenceRequestsStatuses: TenantLicenceStatus[];
    loading: boolean;
}
